import { z } from 'zod/v4';

export const AdminUpdateCompanyParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type AdminUpdateCompanyParams = z.infer<
  typeof AdminUpdateCompanyParamsSchema
>;

export const AdminUpdateCompanyBodySchema = z
  .object({
    isDemoCompany: z.boolean().optional(),
    isClientCompany: z.boolean().optional(),
    parentId: z
      .string()
      .min(1, 'Parent company ID is required')
      .nullable()
      .optional(),
  })
  .refine(body => Object.keys(body).length > 0, {
    message: 'At least one field must be provided',
  });

export type AdminUpdateCompanyBody = z.infer<
  typeof AdminUpdateCompanyBodySchema
>;
